import {Content} from "pdfmake/interfaces";
import {formatDate, primaryColor} from "../consts";
import {ScreenshotCanvasView} from "../types";
import {SectionInterface, SideTypeWithoutTop, StoreWallInterface} from "../../../store/types/store";

const getShelvingView = (side: SideTypeWithoutTop, view: ScreenshotCanvasView): string => {
    let cameraView = ''
    let shelvingView = ''
    if (view === 'front') {
        cameraView = 'фронтальный'
    }
    if (view === 'side') {
        cameraView = 'сбоку'
    }
    if (side === 'left') {
        shelvingView = `(Вид слева, ${cameraView})`
    }
    if (side === 'right') {
        shelvingView = `(Вид справа, ${cameraView})`
    }
    if (side === 'front') {
        shelvingView = `(Вид спереди, ${cameraView})`
    }
    if (side === 'back') {
        shelvingView = `(Вид сзади, ${cameraView})`
    }
    return shelvingView
}

const formatSections = (sections: SectionInterface[], indent: number) => {
    const widthCounts = sections.reduce((acc, section) => {
        // @ts-ignore
        acc[section.width] = (acc[section.width] || 0) + 1;
        return acc;
    }, {});

    const parts = [];
    let totalWidth = 0;

    for (const width in widthCounts) {
        // @ts-ignore
        const count = widthCounts?.[width];
        if (count > 1) {
            parts.push(`${width} * ${count}`);
        } else {
            parts.push(`${width}`);
        }
        totalWidth += +width * count;
    }

    return `${parts.join(' + ')} + ${indent} = ${totalWidth + indent}(мм)`;
}

export const getSideShelvingSystem = (shelving: StoreWallInterface, view: ScreenshotCanvasView) => {
    const shelvingSystem: Content[] = [];

    const shelvingView = getShelvingView(shelving.name, view)

    shelvingSystem.push({
        color: primaryColor,
        text: `Спецификация от ${formatDate} ${shelvingView}`,
        fontSize: 16,
        bold: true,
        margin: [20, 17, 20, 10],
    });
    shelvingSystem.push({
        margin: [0, 30, 0, 10],
        image: (view === 'front' ? shelving.frontSceneImage : shelving.sideSceneImage) || '',
        width: 616,
        height: 319,
        alignment: 'center',
    })
    shelvingSystem.push({
        color: primaryColor,
        margin: [20, 20, 0, 0],
        alignment: 'left',
        text: `Высота, Длина стены под стеллажную конструкцию: ${shelving.height}x${shelving.length}мм`,
    })
    shelvingSystem.push({
        color: primaryColor,
        margin: [20, 20, 0, 0],
        alignment: 'left',
        text: `Габариты стеллажной конструкции`,
    })
    shelvingSystem.push({
        color: primaryColor,
        margin: [20, 0, 0, 0],
        alignment: 'left',
        text: `Высота: ${shelving.height}(мм)`,
    })
    shelvingSystem.push({
        color: primaryColor,
        margin: [20, 0, 0, 0],
        alignment: 'left',
        text: `Ширина: ${formatSections(shelving.sections, shelving.sideIndent)}`,
        pageBreak: 'after'
    })
    return shelvingSystem
}
